import { createSelector } from 'reselect';
import { stateSelector } from './module';
export var featuresSelector = createSelector(stateSelector, function (m) {
  return m.features;
});